import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Videos from "../components/Videos";
import useHttp from "../hooks/use-http";

const SearchFeedPage = () => {
  const params = useParams();
  const searchTerm = params.searchTerm;

  const [videos, setVideos] = useState([]);

  const { sendRequest, loading, error } = useHttp();

  useEffect(() => {
    const dataFetch = async () => {
      const data = await sendRequest(`search?part=snippet&q=${searchTerm}`);

      setVideos(data.items);
    };

    dataFetch();
  }, [searchTerm, sendRequest]);

  return (
    <Box p={2} sx={{ overflowY: "auto", height: "90vh", flex: 8 }}>
      <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: "white" }}>
        Search Result for : {searchTerm}{" "}
        <span style={{ color: "#FC1503" }}>videos</span>
      </Typography>
      <Videos videos={videos} />
    </Box>
  );
};

export default SearchFeedPage;
